export default "__VITE_ASSET__Cy5MXi3N__"